import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Portfolio from "@/pages/Portfolio";
import Admin from "@/pages/Admin";
import { Toaster } from "sonner";
import Loader from "@/components/Loader";
import SmoothScroll from "@/components/SmoothScroll";
import CursorFollower from "@/components/CursorFollower";
import StickyCTA from "@/components/StickyCTA";

function Shell() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  if (isAdmin) {
    // Admin dashboard: skip loader, smooth scroll, cursor follower and sticky CTA.
    return (
      <Routes>
        <Route path="/admin" element={<Admin />} />
      </Routes>
    );
  }

  return (
    <>
      <Loader />
      <CursorFollower />
      <SmoothScroll>
        <Routes>
          <Route path="/" element={<Portfolio />} />
        </Routes>
      </SmoothScroll>
      <StickyCTA />
    </>
  );
}

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0c0c0c",
            border: "1px solid rgba(255,255,255,0.1)",
            color: "#fff",
          },
        }}
      />
    </div>
  );
}

export default App;
